import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useLanguage } from '../../i18n/LanguageContext';
import { getAuditLog } from '../../api/AdminAPI';

const PAGE_SIZE = 25;
const ACTIONS = ['ban', 'unban', 'forceLogout', 'grantAdmin', 'revokeAdmin', 'registrationSettingsChanged', 'announcement'];

export default function AdminAuditLog() {
  const { t } = useLanguage();
  const history = useHistory();

  const [actionFilter, setActionFilter] = useState('');
  const [page, setPage] = useState(1);
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    let cancelled = false;
    (async () => {
      setLoading(true);
      const data = await getAuditLog(token, { page, pageSize: PAGE_SIZE, action: actionFilter });
      if (cancelled) return;
      if (data.status === 'forbidden') { history.replace('/home'); return; }
      if (data.status === 'success') {
        setItems(data.data.items);
        setTotal(data.data.total);
      }
      setLoading(false);
    })();
    return () => { cancelled = true; };
  }, [page, actionFilter, history]);

  const totalPages = Math.max(1, Math.ceil(total / PAGE_SIZE));

  return (
    <div className="PageContainer">
      <div className="PageHeader glass">
        <h4>{t('admin.auditLog.title')}</h4>
        <aside className="descGray">{t('admin.auditLog.subtitle')}</aside>
      </div>
      <div className="Page glass" style={{ overflowY: 'auto' }}>
        <div className="AdminSection">
          <div className="AdminToolbar">
            <select value={actionFilter} onChange={(e) => { setActionFilter(e.target.value); setPage(1); }}>
              <option value="">{t('admin.auditLog.filterAllActions')}</option>
              {ACTIONS.map((a) => <option key={a} value={a}>{t(`admin.auditLog.action.${a}`)}</option>)}
            </select>
          </div>

          {loading ? (
            <p>{t('common.loading')}</p>
          ) : items.length === 0 ? (
            <p className="descGray">{t('admin.auditLog.empty')}</p>
          ) : (
            <div className="AdminTableWrap">
              <table className="AdminTable AdminTableCards">
                <thead>
                  <tr>
                    <th>{t('admin.auditLog.columnTime')}</th>
                    <th>{t('admin.auditLog.columnActor')}</th>
                    <th>{t('admin.auditLog.columnAction')}</th>
                    <th>{t('admin.auditLog.columnTarget')}</th>
                    <th>{t('admin.auditLog.columnDetails')}</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((entry) => (
                    <tr key={entry._id}>
                      <td data-label={t('admin.auditLog.columnTime')}>{new Date(entry.createdAt).toLocaleString()}</td>
                      <td data-label={t('admin.auditLog.columnActor')}>{entry.actorId?.username || '-'}</td>
                      <td data-label={t('admin.auditLog.columnAction')}>{t(`admin.auditLog.action.${entry.action}`)}</td>
                      <td data-label={t('admin.auditLog.columnTarget')}>{entry.targetUserId?.username || '-'}</td>
                      <td data-label={t('admin.auditLog.columnDetails')} style={{ whiteSpace: 'normal', maxWidth: 320 }}>{entry.metadata || ''}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          <div className="AdminPagination">
            <button className="SendButton secondaryColor" disabled={page <= 1} onClick={() => setPage((p) => p - 1)}>{t('admin.auditLog.prev')}</button>
            <span className="descGray">{t('admin.users.pageInfo', { page, total: totalPages })}</span>
            <button className="SendButton secondaryColor" disabled={page >= totalPages} onClick={() => setPage((p) => p + 1)}>{t('admin.auditLog.next')}</button>
          </div>
        </div>
      </div>
    </div>
  );
}
